import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  makeStyles,
  shorthands,
  Text,
  tokens,
  NavDrawer,
  NavDrawerBody,
  NavDrawerHeader,
  NavItem,
  NavSectionHeader,
  Hamburger,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  navDrawer: {
    width: 'auto',
    minWidth: 'fit-content',
    boxShadow: 'inset -2px 0 8px rgba(0, 0, 0, 0.1)',
    zIndex: 1,
  },
  navDrawerHeader: {
    paddingRight: tokens.spacingHorizontalM,
    cursor: 'pointer',
  },
  navItemText: {
    marginRight: `calc(${tokens.spacingHorizontalXXL} * 2)`,
  },
  navBody: {
    ...shorthands.padding('2px', '4px', '8px'),
  },
});

function Navigation({ menuItems, selectedPage, onSelectPage, isExpanded, onToggleExpanded }) {
  const classes = useStyles();
  const navigate = useNavigate();

  // Restore custom active colors by menu item.
  const allItems = [];
  menuItems.forEach((item) => {
    allItems.push(item);
    if (item.children) {
      allItems.push(...item.children);
    }
  });

  const dynamicStyles = allItems
    .map((item) => {
      const escapedId = item.id.replace(/\//g, '\\/');
      return `
        .nav-item-${escapedId}[aria-current="page"]::after {
          background-color: ${item.color} !important;
          transition: background-color 0.3s ease-in-out;
        }
        .nav-item-${escapedId}[aria-current="page"] svg {
          color: ${item.color} !important;
          transition: color 0.3s ease-in-out;
        }
      `;
    })
    .join('\n');

  const handleNavigation = (pageId) => {
    // Navigate using routing
    navigate(`/${pageId === 'home' ? '' : pageId}`);
    // Also call parent component callback if needed
    if (onSelectPage) {
      onSelectPage(pageId);
    }
  };

  return (
    <>
      <style>{dynamicStyles}</style>
      <NavDrawer
        open={true}
        type="inline"
        selectedValue={selectedPage}
        onNavItemSelect={(e, data) => handleNavigation(data.value)}
        className={classes.navDrawer}
      >
        <NavDrawerHeader onClick={onToggleExpanded} className={classes.navDrawerHeader}>
          <Hamburger />
        </NavDrawerHeader>
        <NavDrawerBody density="compact" className={classes.navBody}>
          {menuItems.map((item) => {
            if (item.children) {
              return (
                <React.Fragment key={item.id}>
                  <NavSectionHeader>{isExpanded ? item.label : '\u00A0'}</NavSectionHeader>
                  {item.children.map((child) => (
                    <NavItem
                      key={child.id}
                      icon={child.icon}
                      value={child.id}
                      onClick={() => handleNavigation(child.id)}
                      className={`nav-item-${child.id}`}
                    >
                      {isExpanded ? <Text className={classes.navItemText}>{child.label}</Text> : null}
                    </NavItem>
                  ))}
                </React.Fragment>
              );
            }
            return (
              <NavItem
                key={item.id}
                icon={item.icon}
                value={item.id}
                onClick={() => handleNavigation(item.id)}
                className={`nav-item-${item.id}`}
              >
                {isExpanded ? <Text className={classes.navItemText}>{item.label}</Text> : null}
              </NavItem>
            );
          })}
        </NavDrawerBody>
      </NavDrawer>
    </>
  );
}

export default Navigation;